import React from "react";
import LaunchPicker from "./Launch-picker";
function App() {
  return (
    <div className="App">
      <LaunchPicker></LaunchPicker>
    </div>
  );
}

export default App;
